<template>
  <div>
    <!-- <p>HAAALLLLLLLOOOHAAALLLLLLLOOOHAAALLLLLLLOOOHAAALLLLLLLOOO</p> -->
    <div class="cui__utils__heading"><strong>PATIENT'S JOURNEY</strong></div>
    <div class="row">
      <div class="col-xl-4">
        <div class="card">
          <div class="card-body position-relative overflow-hidden">
            <div class="font-size-36 font-weight-bold text-dark mb-n2">
              {{ verifiedPatientsCount }}
            </div>
            <div class="text-uppercase">
              Verified Patients
              <span class="text-success"> 100 <small> % </small></span>
            </div>
            <div class="small text-muted">Patients approved by verificator</div>
          </div>
        </div>
        <div class="card">
          <div class="card-body position-relative overflow-hidden">
            <div class="font-size-36 font-weight-bold text-dark mb-n2">
              {{ extendingPatientsCount }}
            </div>
            <div class="text-uppercase">
              Extending Patients
              <span class="text-warning">
                {{
                  countPercentage(extendingPatientsCount, verifiedPatientsCount)
                }}
                <small> % </small></span
              >
            </div>
            <div class="small text-muted">
              Patients that clicked extends button
            </div>
          </div>
        </div>
      </div>
      <div class="col-xl-4">
        <div class="card">
          <div class="card-body position-relative overflow-hidden">
            <div class="font-size-36 font-weight-bold text-dark mb-n2">
              {{ activePatientsCount }}
            </div>
            <div class="text-uppercase">
              Scanned Patients (Active Patients)
              <span class="text-warning">
                {{
                  countPercentage(activePatientsCount, verifiedPatientsCount)
                }}
                <small> % </small></span
              >
            </div>
            <div class="small text-muted">
              Patients approved by verificator, and scanned by pharmacy
            </div>
          </div>
        </div>
        <div class="card">
          <div class="card-body position-relative overflow-hidden">
            <div class="font-size-36 font-weight-bold text-dark mb-n2">
              {{ pendingExtendingPatient }}
            </div>
            <div class="text-uppercase">
              Pending Extending Patients
              <span class="text-success">
                {{
                  countPercentage(
                    pendingExtendingPatient,
                    verifiedPatientsCount,
                  )
                }}
                <small> % </small></span
              >
            </div>
            <div class="small text-muted">
              Extending patients that not upload prescription or verified
            </div>
          </div>
        </div>
      </div>
      <div class="col-xl-4">
        <div class="col-xl-12">
          <div class="card">
            <div class="pt-3 pb-1 px-3 position-relative overflow-hidden">
              <h5 class=""><strong>Patients by Gender</strong></h5>
              <div class="d-flex justify-content-between mb-4">
                <pie-chart-legends
                  :maleCount="maleCount"
                  :femaleCount="femaleCount"
                  class="d-flex align-items-center"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div ref="document" class="col-xl-12 col-lg-12">
        <h5 class="mb-4"><strong>Patient Status</strong></h5>
        <div class="mb-5">
          <vue-chartist
            class="height-300"
            type="Bar"
            :data="monthlyPatientData"
            :options="monthlyPatientOptions"
            v-if="!isEmpty1"
          />
          <a-empty v-if="isEmpty1">
            <span slot="description"> Tidak Ada Data </span>
          </a-empty>
          <span
            style="
              display: inline-block;
              background: #41b883;
              width: 15px;
              height: 15px;
              margin-right: 15px;
            "
          >
          </span>
          <span> Pasien Perpanjang </span>
          <span
            style="
              display: inline-block;
              background: #4b7cf3;
              width: 15px;
              height: 15px;
              margin-right: 15px;
              margin-left: 25px;
            "
          >
          </span>
          <span> Pasien Baru </span>
          <span
            style="
              display: inline-block;
              background: #ff0;
              width: 15px;
              height: 15px;
              margin-right: 15px;
              margin-left: 25px;
            "
          >
          </span>
          <span> Pasien Berhenti </span>
        </div>
      </div>
      <!-- Patients by city and program still disabled due to inacurate data -->
      <div ref="document" class="col-xl-6 col-lg-12">
        <h5 class="mb-4">
          <strong>Patients by City</strong>
        </h5>
        <div class="mb-5">
          <vue-chartist
            style="height: 250px"
            type="Bar"
            :data="cityPatientData"
            :options="cityOptions"
            v-if="!isEmpty3"
          />
          <a-empty v-if="isEmpty3">
            <span slot="description"> Tidak Ada Data </span>
          </a-empty>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12 mb-5">
        <h5 class="mb-4">
          <strong>Average DoT, DoE, & DoU per month</strong>
        </h5>
        <div>
          <vue-chartist
            class="height-300"
            type="Line"
            :data="totalDotMonthly"
            :options="totalDotMonthlyOptions"
          />
        </div>
        <span
          style="
            display: inline-block;
            background: #41b883;
            width: 15px;
            height: 15px;
            margin-right: 15px;
          "
        >
        </span>
        <span> Duration of Enrollment </span>
        <span
          style="
            display: inline-block;
            background: #4b7cf3;
            width: 15px;
            height: 15px;
            margin-right: 15px;
            margin-left: 25px;
          "
        >
        </span>
        <span> Duration of Treatment </span>
        <span
          style="
            display: inline-block;
            background: #ff0;
            width: 15px;
            height: 15px;
            margin-right: 15px;
            margin-left: 25px;
          "
        >
        </span>
        <span> Duration of Uncompliance </span>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12">
        <h5 class="mb-4">
          <strong>Rate of Treatment & Rate of Uncompliance</strong>
        </h5>
        <div>
          <vue-chartist
            class="height-300"
            type="Line"
            :data="totalRouMonthly"
            :options="totalDotMonthlyOptions"
          />
        </div>
        <span
          style="
            display: inline-block;
            background: #41b883;
            width: 15px;
            height: 15px;
            margin-right: 15px;
          "
        >
        </span>
        <span> Rate of Treatment (DoT / DoE) </span>
        <span
          style="
            display: inline-block;
            background: #4b7cf3;
            width: 15px;
            height: 15px;
            margin-right: 15px;
            margin-left: 25px;
          "
        >
        </span>
        <span> Rate of Uncompliance (DoU / DoE)</span>
      </div>
    </div>
  </div>
</template>

<script>
import PieChartLegends from '@/components/pie-charts'
import ChartistTooltip from 'chartist-plugin-tooltips-updated'
import ChartistPointlabels from 'chartist-plugin-pointlabels'
import VueChartist from 'v-chartist'
import {
  // getAll,
  getAllByProgram,
  // reportProgramStatusByProgram,
  reportProgramStatus,
  reportPatientByCityPerProgram,
  // reportDoctorByCity,
  // reportTerminateReason,
  // reportArticleTotalViews,
  // reportPatientByProgram,
} from '@/services/axios/api/dashboard'
import moment from 'moment'
const terminatedCol = [
  {
    title: 'Pasien',
    dataIndex: 'code',
    className: 'bg-transparent border-left text-gray-6 width-50',
    scopedSlots: { customRender: 'code' },
    fixed: 'left',
    sorter: (a, b) => {
      return a.code.localeCompare(b.code)
    },
    filters: [],
    onFilter: (value, record) => {
      return record.city === value
    },
  },
  {
    title: 'Tanggal Bergabung',
    dataIndex: 'program.enrollDate',
    className: 'bg-transparent text-gray-6',
    scopedSlots: { customRender: 'enrollDate' },
    sorter: (a, b) => {
      if (!a.program) {
        return -1
      } else if (!b.program) {
        return 1
      } else if (!a.program.enrollDate) {
        return -1
      } else if (!b.program.enrollDate) {
        return 1
      } else {
        return a.program.enrollDate.localeCompare(b.program.enrollDate)
      }
    },
  },
  {
    title: 'Tanggal Berhenti',
    dataIndex: 'program.terminatedDate',
    className: 'bg-transparent text-gray-6',
    scopedSlots: { customRender: 'terminatedDate' },
    sorter: (a, b) => {
      if (!a.program) {
        return -1
      } else if (!b.program) {
        return 1
      } else if (!a.program.terminatedDate) {
        return -1
      } else if (!b.program.terminatedDate) {
        return 1
      } else {
        return a.program.terminatedDate.localeCompare(b.program.terminatedDate)
      }
    },
  },
  {
    title: 'Dokter',
    dataIndex: 'doctor',
    className: 'bg-transparent',
    scopedSlots: { customRender: 'doctor' },
    sorter: (a, b) => {
      if (!a.program) {
        return -1
      } else if (!b.program) {
        return 1
      } else {
        return a.doctor.fullname.localeCompare(b.doctor.fullname)
      }
    },
    filters: [],
    onFilter: (value, record) => {
      return record.doctor ? record.doctor.fullname === value : -1
    },
  },
  {
    title: 'Farmasi',
    dataIndex: 'program.pharmacy',
    className: 'bg-transparent',
    scopedSlots: { customRender: 'pharmacy' },
    sorter: (a, b) => {
      if (!a.program) {
        return -1
      } else if (!b.program) {
        return 1
      } else if (!a.program.pharmacy) {
        return -1
      } else if (!b.program.pharmacy) {
        return 1
      } else {
        return a.program.pharmacy.name.localeCompare(b.program.pharmacy.name)
      }
    },
    filters: [],
    onFilter: (value, record) => {
      return record.pharmacy ? record.pharmacy.name === value : -1
    },
  },
  {
    title: 'Status',
    dataIndex: 'program.isTerminated',
    className: 'bg-transparent',
    scopedSlots: { customRender: 'isTerminated' },
    // filters: [
    //   {
    //     text: 'Belum Terdaftar',
    //     value: 'Belum Terdaftar',
    //   },
    //   {
    //     text: 'Pasien Baru',
    //     value: 'Pasien Baru',
    //   },
    //   {
    //     text: 'Berhenti',
    //     value: 'Berhenti',
    //   },
    //   {
    //     text: 'Perpanjang',
    //     value: 'Perpanjang',
    //   },
    // ],
    onFilter: (value, record) => {
      if (value === 'Belum Terdaftar') return record.program === null
      else if (value === 'Pasien Baru')
        return (
          record.program &&
          record.program.checkPoint !== 6 &&
          record.prevProgram === null &&
          record.isTerminated === null
        )
      else if (value === 'Perpanjang')
        return record.prevProgram && record.isTerminated !== true
      else if (value === 'Berhenti') return record.isTerminated
      else return record.program === value
    },
  },
  {
    title: 'Alasan Berhenti',
    dataIndex: 'terminatedMessage',
    className: 'bg-transparent',
    scopedSlots: { customRender: 'terminatedMessage' },
    filters: [],
    onFilter: (value, record) => {
      return record.terminatedMessage ? record.terminatedMessage === value : 0
    },
  },
]
export default {
  components: {
    PieChartLegends,
    'vue-chartist': VueChartist,
  },
  data() {
    return {
      cancelToken: '',
      terminatedCol,
      totalActive: 0,
      totalCarryOver: 0,
      totalTerminated: 0,
      activePatientsCount: 0,
      registeredPatientsCount: 0,
      registeredUsersCount: 0,
      extendingPatientsCount: 0,
      verifiedPatientsCount: 0,
      registeredUserEmailVerifiedCount: 0,
      registeredUserCompletedProfileCount: 0,
      pendingExtendingPatient: 0,
      totalNewPatients: 0,
      maleCount: 0,
      femaleCount: 0,
      tagrissoCount: 0,
      faslodexCount: 0,
      lynparzaCount: 0,
      totalCarryOverData: {
        series: [],
        label: [],
      },
      totalNewPatientsData: {
        series: [],
        label: [],
      },
      totalDotMonthly: {
        series: [],
        label: [],
      },
      totalRouMonthly: {
        series: [],
        label: [],
      },
      totalTerminatedData: {
        series: [],
        label: [],
      },
      dailyArticleViewsData: {
        series: [],
        label: [],
      },
      terminatedData: [],
      html2pdfoption: {
        html2canvas: {
          onclone: (element) => {
            const svgElements = Array.from(element.querySelectorAll('svg'))
            svgElements.forEach((s) => {
              const bBox = s.getBBox()
              s.setAttribute('x', bBox.x)
              s.setAttribute('y', bBox.y)
              s.setAttribute('width', bBox.width)
              s.setAttribute('height', bBox.height)
            })
          },
        },
      },
      loading: true,
      isTableLoading: true,
      json_data: [],
      terminated_data: [],
      active_data: [],
      isAdmin: false,
      json_fields: {
        No: 'no',
        'Nama Pasien': 'fullname',
        'Kode Pasien': 'code',
        Kota: 'city',
        'Tanggal Gabung': 'enrollDate',
        'Tanggal Berhenti': 'terminatedDate',
        Dokter: 'doctor',
        Farmasi: 'pharmacy',
        Status: 'programstatus',
        'Alasan Berhenti': 'terminatedMessage',
        // "Telephone 2": {
        //   field: "phone.landline",
        //   callback: (value) => {
        //     return `Landline Phone - ${value}`;
        //   },
        // },
      },
      isEmpty1: false,
      isEmpty2: false,
      isEmpty3: false,
      isEmpty4: false,
      isEmpty5: false,
      isEmpty6: false,
      totalPatient: 0,
      totalDoctor: 0,
      totalPharmacy: 0,
      totalLaboratorium: 0,
      totalNews: 0,
      chartOptions: {
        axisX: {
          showLabel: false,
          showGrid: false,
          offset: 0,
        },
        axisY: {
          showLabel: false,
          showGrid: false,
          offset: 0,
        },
        showArea: true,
        high: {
          top: 0,
          right: 0,
          bottom: 0,
          left: 0,
        },
        chartPadding: {
          top: 0,
          right: 0,
          bottom: 0,
          left: 0,
        },
        fullWidth: true,
        height: '110px',
        showPoint: true,
        plugins: [
          ChartistTooltip({
            anchorToPoint: false,
            appendToBody: true,
            seriesName: false,
          }),
        ],
      },
      chartData1: {
        series: [[]],
      },
      chartData2: {
        series: [[]],
      },
      chartData3: {
        series: [[]],
      },
      chartData4: {
        series: [[]],
      },
      monthlyPatientData: {
        labels: [],
        series: [],
      },
      totalDotMonthlyOptions: {
        seriesBarDistance: 10,
        reverseData: false,
        horizontalBars: false,
        axisY: {
          offset: 70,
          showGrid: true,
        },
        axisX: {
          showGrid: true,
        },
        plugins: [
          ChartistTooltip({
            anchorToPoint: false,
            appendToBody: true,
            seriesName: true,
          }),
          ChartistPointlabels({
            textAnchor: 'middle',
            labelInterpolationFnc: (value) => {
              return !value ? 0 : value
            },
          }),
        ],
      },
      monthlyPatientOptions: {
        seriesBarDistance: 25,
        reverseData: false,
        horizontalBars: false,
        axisY: {
          offset: 70,
          showGrid: true,
        },
        axisX: {
          showGrid: true,
        },
        plugins: [
          ChartistTooltip({
            anchorToPoint: false,
            appendToBody: true,
            seriesName: true,
          }),
          ChartistPointlabels({
            textAnchor: 'middle',
            labelInterpolationFnc: (value) => {
              return !value ? 0 : value
            },
          }),
        ],
      },
      cityPatientData: {
        labels: [],
        series: [],
      },
      cityDoctorData: {
        labels: [],
        series: [],
      },
      cityOptions: {
        seriesBarDistance: 1,
        height: '100%',
        reverseData: false,
        horizontalBars: true,
        axisY: {
          offset: 60,
          showGrid: false,
        },
        axisX: {
          showGrid: true,
          labelOffset: {
            x: -5,
            y: 0,
          },
        },
        plugins: [
          ChartistTooltip({
            anchorToPoint: false,
            appendToBody: true,
            seriesName: true,
          }),
        ],
      },
      totalPatientData: {
        labels: [],
        series: [],
        axisY: {
          offset: 70,
          showGrid: false,
        },
        axisX: {
          showGrid: false,
        },
        plugins: [
          ChartistTooltip({
            anchorToPoint: false,
            appendToBody: true,
            seriesName: false,
          }),
        ],
      },
      labelsPieOptions: {
        labelInterpolationFnc(value) {
          return value[0]
        },
        plugins: [
          ChartistTooltip({
            anchorToPoint: false,
            appendToBody: true,
            seriesName: false,
          }),
        ],
      },
      labelsPieResponsiveOptions: [
        [
          'screen and (min-width: 640px)',
          {
            chartPadding: 30,
            labelOffset: 100,
            labelDirection: 'explode',
            labelInterpolationFnc(value) {
              return value
            },
          },
        ],
        [
          'screen and (min-width: 1024px)',
          {
            labelOffset: 80,
            chartPadding: 20,
          },
        ],
      ],
      terminateReasonThisMonth: {
        labels: [],
        series: [],
      },
      terminateReasonAll: {
        labels: [],
        series: [],
      },
    }
  },
  methods: {
    countPercentage(a, b) {
      if (a === 0 && b === 0) {
        return 0
      }
      return Number((a * 100) / b).toFixed(2)
    },
    async getDashboardCardData() {
      const type =
        window.localStorage.getItem('role') !== 'admin' &&
        window.localStorage.getItem('role') !== 'astrazeneca'
          ? window.localStorage.getItem('role')
          : 'imfinzi'
      const res = await getAllByProgram(type)
      console.log(res, 'getDashboardCardData')
      if (res) {
        // this.totalPatient = res.totalPatient ? res.totalPatient : 0
        this.totalDoctor = res.totalDoctor ? res.totalDoctor : 0
        this.totalPharmacy = res.totalPharmacy ? res.totalPharmacy : 0
        this.totalLaboratorium = res.totalLaboratorium
          ? res.totalLaboratorium
          : 0
        this.totalNews = res.totalNews ? res.totalNews : 0
        this.totalActive = res.totalActivePatients ? res.totalActivePatients : 0
        this.totalCarryOver = res.totalCarryoverCount
          ? res.totalCarryoverCount
          : 0
        this.totalTerminated = res.terminatedCount ? res.terminatedCount : 0
        this.totalNewPatients = res.totalNewPatients ? res.totalNewPatients : 0
        this.maleCount = res.patientsByMaleGenderCount
          ? res.patientsByMaleGenderCount
          : 0
        this.registeredPatientsCount = res.registeredPatientsCount
          ? res.registeredPatientsCount
          : 0
        this.registeredUsersCount = res.registeredUsersCount
          ? res.registeredUsersCount
          : 0
        this.activePatientsCount = res.activePatientsCount
          ? res.activePatientsCount
          : 0
        this.extendingPatientsCount = res.extendingPatientCount
          ? res.extendingPatientCount
          : 0
        this.verifiedPatientsCount = res.verifiedPatientsCount
          ? res.verifiedPatientsCount
          : 0
        this.femaleCount = res.patientsByFemaleGenderCount
          ? res.patientsByFemaleGenderCount
          : 0
        this.registeredUserCompletedProfileCount = res.registeredUserCompletedProfileCount
          ? res.registeredUserCompletedProfileCount
          : 0
        this.registeredUserEmailVerifiedCount = res.registeredUserEmailVerifiedCount
          ? res.registeredUserEmailVerifiedCount
          : 0
        this.pendingExtendingPatient = res.pendingExtendingPatient
          ? res.pendingExtendingPatient
          : 0
      }
    },
    async reportProgramStatusData() {
      const type = 'imfinzi'
      const start = moment().format('YYYY-MM-DD')
      const res = await reportProgramStatus(start, this.cancelToken, type)
      // console.log(res, 'reportProgramStatusData')
      if (res && res.length) {
        const enroll = []
        const terminate = []
        const carryover = []
        const label = []
        const active = []
        const patients = []
        const doctors = []
        const pharmacies = []
        const laboratories = []
        const dot = []
        const doe = []
        const dou = []
        const rot = []
        const rou = []

        const targetPatients = []

        let isEmpty = true
        res.forEach((item) => {
          patients.push(item.patients)
          doctors.push(item.doctors)
          pharmacies.push(item.pharmacies)
          laboratories.push(item.laboratories)
          if (
            item.enroll ||
            item.terminate ||
            item.carryover ||
            item.active ||
            item.targetPatients[0]
          ) {
            if (item.targetPatients[0])
              targetPatients.push(item.targetPatients[0].total)
            else targetPatients.push(0)
            enroll.push(item.enroll)
            terminate.push(item.terminate)
            dot.push(item.dotAvg.toFixed(2))
            doe.push(item.doeAvg.toFixed(2))
            dou.push(item.douAvg.toFixed(2))
            rou.push(Math.round((item.dou / item.doe) * 100) / 100)
            rot.push(Math.round((item.dot / item.doe) * 100) / 100)
            carryover.push(item.carryover)
            label.push(item.label)
            active.push(item.active)
            // this.totalActive += item.active
            // this.totalCarryOver += item.carryover
            isEmpty = false
          }
        })
        console.log(carryover, 'carryover')
        // console.log(totalActive, 'active')
        this.isEmpty1 = isEmpty
        this.isEmpty2 = isEmpty

        this.monthlyPatientData.labels = label
        const enrollData = {
          name: 'Pasien Baru',
          data: enroll,
        }
        const terminateData = {
          name: 'Pasien Berhenti',
          data: terminate,
        }
        const carryoverData = {
          name: 'Pasien Perpanjang',
          data: carryover,
        }
        // const targetPatientData = {
        //   name: 'Target Pasien',
        //   data: targetPatients,
        // }

        this.monthlyPatientData.series.push(enrollData)
        this.monthlyPatientData.series.push(carryoverData)
        this.monthlyPatientData.series.push(terminateData)
        // this.monthlyPatientData.series.push(targetPatientData)

        patients.forEach((x) => {
          this.chartData1.series[0].push(x)
        })

        doctors.forEach((x) => {
          this.chartData2.series[0].push(x)
        })

        pharmacies.forEach((x) => {
          this.chartData3.series[0].push(x)
        })

        laboratories.forEach((x) => {
          this.chartData4.series[0].push(x)
        })

        this.totalPatientData.labels = label
        this.totalPatientData.series.push(active)

        this.totalCarryOverData.labels = label
        this.totalCarryOverData.series.push(carryover)

        this.totalNewPatientsData.labels = label
        this.totalNewPatientsData.series.push(enroll)

        this.totalDotMonthly.labels = label
        this.totalDotMonthly.series.push(dot)
        this.totalDotMonthly.series.push(doe)
        this.totalDotMonthly.series.push(dou)

        this.totalRouMonthly.labels = label
        this.totalRouMonthly.series.push(rou)
        this.totalRouMonthly.series.push(rot)

        this.totalTerminatedData.labels = label
        this.totalTerminatedData.series.push(terminate)
        console.log(this.monthlyPatientData, '<<<<< HALLO')
      } else {
        this.isEmpty1 = true
        this.isEmpty2 = true
      }
    },
    async reportProgramByCityPerProgram() {
      const type = 'imfinzi'
      const res = await reportPatientByCityPerProgram(type)
      // console.log(res, 'reportPatientByCityData')
      if (res && res.length) {
        const data = []
        const label = []

        let isEmpty = true
        res.forEach((item) => {
          if (item.count) {
            label.push(item.label)
            data.push({ meta: item.label, value: item.count })
            isEmpty = false
          }
        })
        this.isEmpty3 = isEmpty
        console.log({ label, data })
        this.cityPatientData.labels = label
        this.cityPatientData.series.push(data)
      } else {
        this.isEmpty3 = true
      }
    },
  },
  created() {
    this.getDashboardCardData()
    this.reportProgramStatusData()
    this.reportProgramByCityPerProgram()
  },
}
</script>
